<template>
  <v-container fluid>
    <events-agenda/>
  </v-container>
</template>

<script>
  export default {
    name: 'Agenda',

    components: {
      EventsAgenda: () => import ('@/components/events_agenda/EventsAgenda.vue')
    },

  }
</script>

<style lang="scss" scoped>

</style>